export function randomArrayItem(arr: unknown[]) {
  return arr[Math.floor(Math.random() * arr.length)]
}
